export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const IDENTITY_URL = process.env.REACT_APP_IDENTITY_URL;
export const IDENTITY_CLIENT_ID = process.env.REACT_APP_IDENTITY_CLIENT_ID;
export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const INVENTORY_SERVICE_URL = process.env.REACT_APP_INVENTORY_SERVICE_URL
export const HOTEL_AI_URL = process.env.REACT_APP_HOTEL_AI_URL
export const ASSETS_API_URL = process.env.REACT_APP_ASSETS_API_URL
export const GOOGLE_REFRESH_TOKEN = process.env.REACT_APP_GOOGLE_REFRESH_TOKEN
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY